import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

// import { downloadProductDocument } from '../Form/actionCreator';

class Download extends Component {

  componentDidMount() {
    // const { match, history } = this.props;
    //
    // const search = history.location.search;
    // const searchParams = search.split('=');
    // const docName = searchParams.length > 1 ? searchParams[1] : 'Document';
    // this.props.downloadProductDocument(match.params.iddocument, docName);
  }
  render() {
    return null;
  }
}

const mapDispatchToProps = {
  // downloadProductDocument
};

Download.propTypes = {
  // downloadProductDocument: PropTypes.func,
  match: PropTypes.object,
  history: PropTypes.object
};


export default withRouter(connect(null, mapDispatchToProps)(Download));
